import { FC, SVGProps } from 'react'

export const Plus: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M21.5501 11.8896C21.5501 12.3421 21.1832 12.709 20.7307 12.709L12.8194 12.709L12.8194 20.6401C12.8194 21.0927 12.4525 21.4596 11.9999 21.4596C11.5474 21.4596 11.1805 21.0927 11.1805 20.6401L11.1805 12.709L3.26922 12.709C2.81665 12.709 2.44978 12.3421 2.44978 11.8896C2.44978 11.437 2.81665 11.0701 3.26922 11.0701L11.1805 11.0701L11.1805 3.17869C11.1805 2.72613 11.5474 2.35926 11.9999 2.35926C12.4525 2.35926 12.8194 2.72613 12.8194 3.17869L12.8194 11.0701L20.7307 11.0701C21.1832 11.0701 21.5501 11.437 21.5501 11.8896Z"
			fill="currentColor"
		/>
	</svg>
)
